module.exports = __webpack_public_path__ + "img/04-12.8e9fcaf1.png";